import { render } from "./CertHygienePending.vue?vue&type=template&id=a4bb76d8&scoped=true"
import script from "./CertHygienePending.vue?vue&type=script&lang=js"
export * from "./CertHygienePending.vue?vue&type=script&lang=js"

import "./CertHygienePending.vue?vue&type=style&index=0&id=a4bb76d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4bb76d8"]])

export default __exports__